import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { Toaster } from "react-hot-toast";
import { SessionProvider } from "@/auth/SessionProvider";
import { bootDirectoryTheme, ThemeProvider } from "@/components/ThemeProvider";
import { App } from "./App";
import "./index.css";

bootDirectoryTheme();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <BrowserRouter>
      <ThemeProvider>
        <SessionProvider>
          <App />
          <Toaster position="top-center" />
        </SessionProvider>
      </ThemeProvider>
    </BrowserRouter>
  </StrictMode>,
);
